export default function CricketRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 18px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    .modal-body{
                        text-align: left;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>CricketX</b></h1>
                                    </center>

                                    <hr></hr>
                                    <div>
                                        <h3><b>GAME RULES</b></h3>
                                        <p class="pt20">
                                        </p><ol>
                                            <li>1. Enter the desired amount in the betting line. You have the option to place one or two bets on the same flight.</li>
                                            <li>2. Click the "Place" button and observe the height the ball will reach. The ball height is unpredictable and varies from 1 to infinity.</li>
                                            <li>3. Use "CashOut" before the explosion or set an "Auto CashOut" value beforehand to exit the game automatically.</li>
                                            <li>4. Each bet can be set manually or automatically with a pre-defined stake and collect multiplier.</li>
                                            <li>5. The "Auto Bet" and "Auto Collect" features are activated after enabling them before a new round starts. Minimum odd for auto CashOut is 1.1</li>
                                            <li>6. On the bottom of the game panel, a history of coefficient statistics is displayed after each round explosion</li>
                                            <li>7. You can only cancel your bet before the game starts.</li>
                                        </ol>
                                        <p></p>
                                        <p class="pt20 notice" style={{ color: "red" }}>
                                            A stable internet connection is required to play CricketX.
                                            If players are unable to collect due to poor internet connectivity,
                                            the bet will be considered lost.
                                        </p>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}